var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "advisory-banner" }, [
      _c("table", [
        _c("tr", [
          _c("td", {}, [
            _c(
              "div",
              {
                staticStyle: { "margin-bottom": "0px", "padding-top": "10px" },
                attrs: { id: "topbanner" }
              },
              [
                _c("p", { staticStyle: { "text-align": "center" } }, [
                  _c("u", [
                    _vm._v("Upcoming Spring 2027 Application Deadlines:")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { padding: "10px" } }, [
              _c("div", { staticClass: "container-banner " }, [
                _c("div", { staticClass: "column" }, [
                  _c("p", [
                    _vm._v(
                      "BA in Psychology (All Tracks) - December 1 , 2026\t\t\t\t\t\t\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Bachelor’s in Accounting - December 1 , 2026")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("\tBachelor’s in Business - December 1 , 2026\t\t")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Bachelor’s in Legal Studies - December 1 , 2026\t")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column" }, [
                  _c("p", [
                    _vm._v(
                      "Master’s/Adv. Certificate in ABA - December 1 , 2026"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Master’s in Accounting (Men) - December 1 , 2026")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Master’s in Education - December 1 , 2026\t")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "SLP/ Medical/ Nutrition/ OT Prerequisites  - December 1 , 2026\t"
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("p", { staticStyle: { "text-align": "center" } }, [
                _c("u", [_vm._v("Upcoming Fall 2027 Application Deadlines:")])
              ]),
              _vm._v(" "),
              _c("p", { staticStyle: { "text-align": "center" } }, [
                _vm._v(
                  "Doctorate in Counseling Psychology (PsyD) - Dec. 1, 2026\n\t\t\t\t\t\t"
                )
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f13d420", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f13d420","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/AdvisoryBanner.vue
// module id = 381
// module chunks = 19